/* eslint-disable no-console */
import { getModelContentDivByName } from '../steps/model';
import { scrollToElement } from '../../../utils/scrolling-utils';

const getHeaderOffset = () => {
  const header = document.querySelector('.primary-nav-wrapper');
  if (header !== null) {
    return (header.offsetHeight + 15) * -1;
  }
  return 0;
};

const scrollToSection = (name, state) => {
  const { model } = state;
  setTimeout(() => {
    // Get offset for fixed header
    const offset = getHeaderOffset();
    // Check if model, scroll to model w/in accordion
    let element = document.querySelector(`[data-step="${name}"]`);
    if (name === 'model' && model !== '') {
      element = getModelContentDivByName(model);
    }
    scrollToElement({
      element,
      offset,
    });
  }, 100);
};

const scrollToError = (name) => {
  setTimeout(() => {
    // Get offset for fixed header
    const offset = getHeaderOffset();
    const element = document.querySelector(`[data-step-error="${name}"]`);
    scrollToElement({
      element,
      offset,
    });
  }, 100);
};

const toggleOptionStepsAvailability = (step, options) => {
  // Get all options in step
  const optionList = document.querySelectorAll(`[data-step="${step}"] .option-item`);
  [].map.call(optionList, (item) => {
    const optionIpt = item.querySelector('input');
    if (options.indexOf(optionIpt.value) !== -1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
};

const resetStepSelections = (step) => {
  // Get all options in step
  const optionList = document.querySelectorAll(`[data-step="${step}"] .option-item, [data-step="${step}"] .swatch-checkbox`);
  [].map.call(optionList, (item) => {
    const optionIpt = item.querySelector('input');
    optionIpt.checked = false;
  });
};


const isProUpgradable = (modelCode, fabricCollection) => {
  const xx = ['M', 'MXL', 'M-P', 'MXL-P', '8--2', '8--6'];
  return xx.includes(modelCode) && fabricCollection.indexOf('Laminated') > -1;
};

const isProModel = (modelCode) => {
  const xx = ['MPROXL', 'MPRO', 'MPRO-P', 'MPROXL-P', '8--4', '8--7'];
  return xx.includes(modelCode);
};

const hasLed = (modelCode) => {
  const xx = ['MPROXL', 'MPRO', 'MPRO-P', 'MPROXL-P', '8--4', '8--7', 'M', 'MXL', 'M-P', 'MXL-P', '8--2', '8--6'];
  return xx.includes(modelCode)
    || modelCode.toLowerCase().indexOf('motor') > -1;
};


const isStepHidden = step => (
  document.querySelectorAll(`[data-step="${step}"].hidden`).length > 0
);

const getAvailableOptions = step => (
  document.querySelectorAll(`[data-step="${step}"]:not(.hidden)`)
);

const toggleStepAvailability = (step, options) => {
  const stepWrappers = document.querySelectorAll(`[data-step="${step}"]`);
  if (stepWrappers.length === 0) {
    return;
  }
  [].map.call(stepWrappers, (item) => {
    if (options.length > 1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
  toggleOptionStepsAvailability(step, options);
};

const toggleStepByName = (name, status) => {
  const stepWrappers = document.querySelectorAll(`[data-step="${name}"]`);
  [].map.call(stepWrappers, (step) => {
    if (status === 'show') {
      step.classList.remove('hidden');
    } else {
      step.classList.add('hidden');
    }
  });
};

const toggleStepTitleByName = (name, status) => {
  const stepTitle = document.querySelector(`.build-awning-step-heading[data-step="${name}"]`);
  if (status === 'show' && stepTitle) {
    stepTitle.classList.remove('hidden');
  } else if (status === 'hide' && stepTitle) {
    stepTitle.classList.add('hidden');
  }
};

const updateAvailableStepNums = () => {
  const stepHeaders = document.querySelectorAll('.build-awning-step-heading .step-num');
  const availableSteps = [].filter.call(stepHeaders, step => step.closest('[data-step]:not(.hidden)'));
  availableSteps.forEach((step, index) => {
    step.textContent = index + 1;
  });
};

const isStepOnPage = step => (
  document.getElementById(step) !== null
);

export {
  getAvailableOptions,
  isStepHidden,
  isStepOnPage,
  resetStepSelections,
  scrollToError,
  scrollToSection,
  toggleStepAvailability,
  toggleStepByName,
  toggleStepTitleByName,
  updateAvailableStepNums,
  isProUpgradable,
  isProModel,
  hasLed,
};
/* eslint-enable no-console */
